import RouterView from '@/page/main/DefaultRouterView'


import UnitList from '@/page/storage/unitList'
import SupplierList from '@/page/asset/supplierList'
// 物品基本信息管理
import ConsumableList from '@/page/consumable/consumableList'
// 物品类别管理
import ConsumableTypeList from '@/page/consumable/consumableTypeList'


// 业务功能

// 物品使用/领用
// import Out from '@/page/consumable/Out'
// import OutList from '@/page/consumable/OutList'
// 物品实时库存
import RoomDetail from '@/page/consumable/roomDetail'
// 物品入库
import In from '@/page/consumable/In'
import InList from '@/page/consumable/InList'
import InDetailList from '@/page/consumable/InDetailList'
// 物品领用、出库
import Use from '@/page/consumable/Use'
import UseList from '@/page/consumable/UseList'
import UseDetailList from '@/page/consumable/UseDetailList'
// 领用汇总
import UseApplyDetailList from '@/page/consumable/UseApplyDetailList'
// 物品退库
import Back from '@/page/consumable/Back'
import BackList from '@/page/consumable/BackList'
import BackDetailList from '@/page/consumable/BackDetailList'
// 物品盘点
import Inventory from '@/page/consumable/Inventory'
import InventoryList from '@/page/consumable/InventoryList'
import InventoryDetailList from '@/page/consumable/InventoryDetailList'
// 申购
import Apply from '@/page/consumable/Apply'
import ApplyList from '@/page/consumable/ApplyList'
import ApplyDetailList from '@/page/consumable/ApplyDetailList'
// 采购计划表
import PlanApply from '@/page/consumable/PlanApply'
import PlanApplyList from '@/page/consumable/PlanApplyList'


export default {
  path: '/Consumable',
  component: RouterView,
  children: [
    // 业务功能

    // 盘点
    {
      path: 'Inventory',
      meta: {
        type: ['consumable', 'inventoryList'],
        title: '物品盘点'
      },
      component: Inventory
    }, {
      path: 'InventoryList',
      meta: {
        type: ['consumable', 'inventoryList'],
        title: '物品盘点列表'
      },
      component: InventoryList
    }, {
      path: 'InventoryDetailList',
      meta: {
        type: ['consumable', 'inventoryDetailList'],
        title: '物品盘存损益明细列表'
      },
      component: InventoryDetailList
    }, 
    // 退库
    {
      path: 'Back',
      meta: {
        type: ['consumable', 'backList'],
        title: '退库物品申请'
      },
      component: Back
    }, {
      path: 'BackList',
      meta: {
        type: ['consumable', 'backList'],
        title: '退库物品申请列表'
      },
      component: BackList
    }, {
      path: 'BackDetailList',
      meta: {
        type: ['consumable', 'backDetailList'],
        title: '退库出库明细列表'
      },
      component: BackDetailList
    },
    // 领用
    {
      path: 'Use',
      meta: {
        type: ['consumable', 'useList'],
        title: '领用物品申请'
      },
      component: Use
    }, {
      path: 'UseList',
      meta: {
        type: ['consumable', 'useList'],
        title: '领用物品申请列表'
      },
      component: UseList
    }, {
      path: 'UseDetailList',
      meta: {
        type: ['consumable', 'useDetailList'],
        title: '物品出库明细列表'
      },
      component: UseDetailList
    }, {
      path: 'UseApplyDetailList',
      meta: {
        type: ['consumable', 'UseApplyDetailList'],
        title: '物品出库汇总表'
      },
      component: UseApplyDetailList
    },


    // 使用/领用登记
    // {
    //   path: 'Out',
    //   meta: {
    //     type: ['consumable', 'outList'],
    //     title: '使用/领用登记'
    //   },
    //   component: Out
    // }, {
    //   path: 'OutList',
    //   meta: {
    //     type: ['consumable', 'outList'],
    //     title: '使用/领用登记列表'
    //   },
    //   component:OutList
    // }, 
    // 实时库存
    {
      path: 'Detail',
      meta: {
        type: ['consumable', 'realTimeList'],
        title: '实时库存查询'
      },
      component: RoomDetail
    },
    // 入库相关
    {
      path: 'In',
      meta: {
        type: ['consumable', 'inList'],
        title: '物品入库'
      },
      component: In
    }, {
      path: 'InList',
      meta: {
        type: ['consumable', 'inList'],
        title: '物品入库单列表'
      },
      component: InList
    }, {
      path: 'InDetailList',
      meta: {
        type: ['consumable', 'inDetailList'],
        title: '物品入库明细列表'
      },
      component: InDetailList
    },
    // 采购计划表
    {
      path: 'PlanApply',
      meta: {
        type: ['consumable', 'consumablePlanApplyList'],
        title: '物品申购列表'
      },
      component: PlanApply
    }, {
      path: 'PlanApplyList',
      meta: {
        type: ['consumable', 'consumablePlanApplyList'],
        title: '物品申购列表'
      },
      component: PlanApplyList
    },
    // 物品申购
    {
      path: 'Apply',
      meta: {
        type: ['consumable', 'consumableApplyList'],
        title: '物品申购列表'
      },
      component: Apply
    }, {
      path: 'ApplyList',
      meta: {
        type: ['consumable', 'consumableApplyList'],
        title: '物品申购列表'
      },
      component: ApplyList
    }, {
      path: 'ApplyDetailList',
      meta: {
        type: ['consumable', 'consumableApplyDetailList'],
        title: '物品申购汇总列表'
      },
      component: ApplyDetailList
    },

    // 基础资料
    {
      path: 'UnitList',
      meta: {
        type: ['consumable', 'unitList'],
        title: '计量单位列表'
      },
      component: UnitList
    }, {
      path: 'SupplierList/:type',
      meta: {
        type: ['consumable', 'consumableSupplierList'],
        title: '易耗品供应商列表'
      },
      component: SupplierList
    }, {
      path: 'ConsumableInfoList',
      meta: {
        type: ['consumable', 'consumableList'],
        title: '易耗品基础资料管理'
      },
      component: ConsumableList
    }, {
      path: 'ConsumableTypeList',
      meta: {
        type: ['consumable', 'consumableTypeList'],
        title: '易耗品类别管理'
      },
      component: ConsumableTypeList
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/consumable.js